import { Trans, useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { apiGetHfComorbiditiesPatientId } from "../../../api";
import { AppModel } from "../../../app/app-model";
import { AddButton } from "../../../components/ui-kit/add-button";
import { useFetch } from "../../../utils/use-fetch";
import { PatientSubpage } from "../common/patient-subpage";
import { DiagnosesItem } from "./diagnoses";
import { DiagnosesTable } from "./diagnoses-table";

export const DiagnosesRoute = observer(function DiagnosesRoute(props: {
  app: AppModel;
}) {
  const { t } = useLingui();
  const patient = props.app.requirePatient();
  const api = props.app.seerlinqApi;
  const [data, setData] = useState<DiagnosesItem[]>([]);

  const { loading, refetch } = useFetch(
    async ({ isRefetch }) => {
      const response = await apiGetHfComorbiditiesPatientId({
        path: { patient_id: patient.patientId },
        meta: { useSessionCache: !isRefetch },
      });
      setData(response.data.diagnoses);
    },
    [patient.patientId],
  );

  return (
    <PatientSubpage title={t`Comorbidities`} loading={loading}>
      <DiagnosesTable
        filterActions={
          <AddButton href="add">
            <Trans>Add comorbidities</Trans>
          </AddButton>
        }
        api={api}
        data={data}
        onInvalidated={refetch}
        patient={patient}
        persistState
      />
    </PatientSubpage>
  );
});
